'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = order;

var _flash = require('../actions/flash');

function order() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _flash.SET_FLASH:
      return action.flash;
    case _flash.CLEAR_FLASH:
      return {};
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/flash.js
// module id = 2528
// module chunks = 0